export const FIELD = "draggableField";
